import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Select, Input } from 'next/components/ui';
import { URLShape } from 'next/entities/rules';

import { Clause } from './styled';

const OPERATORS = [
  { label: 'starts with', value: '^' },
  { label: "doesn't start with", value: '!^' },
  { label: 'ends with', value: '$' },
  { label: "doesn't end with", value: '!$' },
  { label: 'contains', value: '*' },
  { label: "doesn't contain", value: '!*' },
  { label: 'equals', value: '==' },
  { label: "doesn't equal", value: '!=' },
  { label: 'matches regex', value: 'regex' },
];

export const UrlClause = ({ conditions, onChange }) => {
  const valueRef = useRef();

  const {
    url: { operator: currentOperator, value: currentValue = '' },
  } = conditions;

  useEffect(() => {
    if (valueRef.current) {
      valueRef.current.value = currentValue;
    }
  }, [currentValue]);

  const handleChange = changes =>
    void onChange({
      url: { ...conditions.url, ...changes },
    });

  const handleOperatorChange = ({ value: operator }) =>
    void handleChange({ operator });

  const handleValueBlur = ({ target: { value } }) =>
    void handleChange({ value });

  return (
    <Clause>
      <Select
        name="operator"
        value={OPERATORS.find(({ value }) => value === currentOperator)}
        options={OPERATORS}
        onChange={handleOperatorChange}
        portal
      />
      <Input
        type="text"
        aria-label="value"
        name="value"
        ref={valueRef}
        defaultValue={currentValue}
        placeholder="e.g. /account"
        onBlur={handleValueBlur}
      />
    </Clause>
  );
};

UrlClause.propTypes = {
  conditions: URLShape,
  onChange: PropTypes.func,
};
